import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

export function createCompanyForm(): FormGroup {
  return new FormBuilder().group({
    name: new FormControl(null, Validators.required),
    urlReg: new FormControl(null, Validators.required),
    pipelineID: new FormControl(null, Validators.required),
    dealstageID: new FormControl(null, Validators.required),
    activeTypePayment: new FormControl(null, Validators.required),
    payuClientId: new FormControl(null),
    payuClientSecret: new FormControl(null),
    stripeSecretKey: new FormControl(null),
    paynowAPIKey: new FormControl(null),
    paynowAPIsignature: new FormControl(null),
    fakturowniaNameAccount: new FormControl(null),
    fakturowniaAPIKey: new FormControl(null),
    department_id: new FormControl(null),
    confirmEmail_id_pl: new FormControl(null),
    confirmEmail_id_en: new FormControl(null),
    invoice_id_pl: new FormControl(null),
    invoice_id_en: new FormControl(null),
    group_mail_id: new FormControl(null),
    active: new FormControl(0),
    consentPersonalData_pl: new FormControl(null, Validators.required),
    consentPersonalData_en: new FormControl(null, Validators.required),
    consentPersonalData_HS: new FormControl(null, Validators.required),
    consentSalesAndMarketing_pl: new FormControl(null, Validators.required),
    consentSalesAndMarketing_en: new FormControl(null, Validators.required),
    consentSalesAndMarketing_HS: new FormControl(null, Validators.required),
    title_confirmedRegSubject_pl: new FormControl(null, Validators.required),
    confirmedRegSubject_pl: new FormControl(null, Validators.required),
    title_confirmedRegSubject_en: new FormControl(null, Validators.required),
    confirmedRegSubject_en: new FormControl(null, Validators.required),
    title_vindication_partI_pl: new FormControl(null, Validators.required),
    title_vindication_partI_en: new FormControl(null, Validators.required),
    vindication_partI_pl: new FormControl(null, Validators.required),
    vindication_partI_en: new FormControl(null, Validators.required),
    title_vindication_partII_pl: new FormControl(null, Validators.required),
    title_vindication_partII_en: new FormControl(null, Validators.required),
    vindication_partII_pl: new FormControl(null, Validators.required),
    vindication_partII_en: new FormControl(null, Validators.required),
    title_vindication_partIII_pl: new FormControl(null, Validators.required),
    title_vindication_partIII_en: new FormControl(null, Validators.required),
    vindication_partIII_pl: new FormControl(null, Validators.required),
    vindication_partIII_en: new FormControl(null, Validators.required),
    title_vindication_partIV_pl: new FormControl(null, Validators.required),
    title_vindication_partIV_en: new FormControl(null, Validators.required),
    vindication_partIV_pl: new FormControl(null, Validators.required),
    vindication_partIV_en: new FormControl(null, Validators.required),
    title_vindication_partV_pl: new FormControl(null, Validators.required),
    title_vindication_partV_en: new FormControl(null, Validators.required),
    vindication_partV_pl: new FormControl(null, Validators.required),
    vindication_partV_en: new FormControl(null, Validators.required),
  });
}
